import { required, minLength } from '@vuelidate/validators';

export const getSectorNameErrorMessage = validation => {
  if (!validation.name.$error) return '';
  if (!validation.name.required) return 'SECTOR_MGMT.FORM.NAME.REQUIRED_ERROR';
  if (!validation.name.minLength) return 'SECTOR_MGMT.FORM.NAME.MINIMUM_LENGTH_ERROR';
  return '';
};

export default {
  name: {
    required,
    minLength: minLength(2),
  },
  description: {},
};
